/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Component } from '@angular/core';

@Component({
	selector: 'empty',
	template: '',
})
export class EmptyComponent {}
